import React from 'react';
import { CelebrationOverlayProps } from '../../../presentation/GamePresentationTypes';
import { HeartsShootTheMoonAnimation } from './HeartsShootTheMoonAnimation';

/**
 * Hearts-specific Hand-End Celebration Overlay.
 *
 * Owned exclusively by the Hearts module:
 * Activates when a player shoots the moon (takes all 13 Hearts + Queen of Spades, 26 penalty points),
 * rendering the celestial Shoot the Moon rising moon, orbiting cards, and shooter spotlight.
 */
export const HeartsCelebrationOverlay: React.FC<CelebrationOverlayProps> = ({
  isOpen,
  isUserTeam = true,
  winningTeam,
  gameState,
  mySeat,
}) => {
  const userSeat = mySeat !== null && mySeat !== undefined ? Number(mySeat) : null;

  // Authoritative Moon Shot status from gameState
  const rawMoonSeat = gameState?.shotTheMoonSeat ??
    (gameState as any)?.shotMoonSeat ??
    (gameState?.gameExt as any)?.shotTheMoonSeat;

  const shooterSeat = rawMoonSeat !== null && rawMoonSeat !== undefined && Number(rawMoonSeat) >= 0
    ? Number(rawMoonSeat)
    : (winningTeam !== undefined ? winningTeam - 1 : 0);

  const shooterPlayer = gameState?.seats?.[shooterSeat];
  const isUserShooter = userSeat !== null && userSeat === shooterSeat;

  return (
    <HeartsShootTheMoonAnimation
      isOpen={isOpen}
      isUserShooter={isUserShooter}
      shooterName={shooterPlayer?.name || `Seat ${shooterSeat + 1}`}
      shooterAvatarUrl={shooterPlayer?.avatarUrl || shooterPlayer?.originalAvatarUrl || undefined}
      isBot={Boolean(shooterPlayer?.isBot)}
      shootTheMoonRule={(gameState?.shootTheMoonRule ?? (gameState?.gameExt as any)?.shootTheMoonRule) as string}
      shootTheMoonChoice={(gameState?.shootTheMoonChoice ?? (gameState?.gameExt as any)?.shootTheMoonChoice) as string | null}
      points={Number(gameState?.shootTheMoonPoints ?? (gameState?.gameExt as any)?.shootTheMoonPoints ?? 26)}
    />
  );
};
